module.exports = __webpack_public_path__ + "img/bg.c2478cb0.jpg";